import React from "react";
import { useTranslation } from "react-i18next";
import "./languageswitcher.css";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language || "en";
  const isEn = currentLang.startsWith("en");

  const toggleLanguage = () => {
    const newLang = isEn ? "id" : "en";
    i18n.changeLanguage(newLang);
  };

  return (
    <div className="language-switcher" onClick={toggleLanguage}>
      <div className={`switcher-thumb ${isEn ? "en" : "id"}`}></div>
      <span className={`lang-text id-text ${!isEn ? "active" : ""}`}>ID</span>
      <span className={`lang-text en-text ${isEn ? "active" : ""}`}>EN</span>
    </div>
  );
};

export default LanguageSwitcher;
